import { React, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import AppRoutes from "./routes/AppRoutes";
import useIdleTimer from "../shared/hooks/useIdleTimer";
import { createNotification } from "../shared/components/Popup";

function App() {
  useEffect(() => {
    window.scrollTo(0, 1);
    const handleResize = () => {
      window.scrollTo(0, 1);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isIdle = useIdleTimer(600000); // 10-minute session timeout

  if (isIdle) {
    window.location.href = "/";
    sessionStorage.clear();
    localStorage.clear();
    const info = { type: "error", message: "Session expired" };
    return createNotification(info)();
  }

  return (
    <div className="App">
      <NotificationContainer />
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App;
